<app-screen-shell [contentClass]="showLanguageSelection ? 'public-entry-shell' : 'public-match-page'" [layout]="showLanguageSelection ? 'public-entry' : 'default'" variant="public" [showHeader]="false">
  @if (guestContinuationClaimed) {
    <section class="guest-continuation-claimed" role="alertdialog" aria-modal="true" [attr.aria-labelledby]="'guestContinuation.claimedTitle' | translate">
      <div class="guest-continuation-claimed-card">
        <span class="guest-continuation-claimed-icon" aria-hidden="true">
          <i [class]="'common.check' | nogoshIcon"></i>
        </span>
        <h1>{{ 'guestContinuation.claimedTitle' | translate }}</h1>
        <p>{{ 'guestContinuation.claimedDescription' | translate }}</p>
        <strong>{{ invite && invite.name }}</strong>
        <button type="button" class="guest-continuation-claimed-action" (click)="openClaimedMatchInApp()">
          {{ 'guestContinuation.openInApp' | translate }}
        </button>
      </div>
    </section>
  }
  @if (guestContinuationObserverError && !guestContinuationClaimed) {
    <section class="guest-continuation-observer-error" role="status">
      <span>{{ 'guestContinuation.observerError' | translate }}</span>
      <button type="button" (click)="retryGuestContinuationObserver()">{{ 'guestContinuation.checkAgain' | translate }}</button>
    </section>
  }
  @if (showLanguageSelection) {
    <section class="public-language-panel" aria-labelledby="public-language-title">
      <img class="public-language-logo" src="assets/images/footballer-zone-logo-transparent.png" alt="Footballer.zone">
      <h1 id="public-language-title">{{ 'splashLanguage.dropdownTitle' | translate }}</h1>

      <div class="public-language-options" role="radiogroup" [attr.aria-label]="'splashLanguage.dropdownTitle' | translate">
        <button
          type="button"
          class="public-language-option"
          role="radio"
          [class.selected]="isSelectedLanguage('en')"
          [attr.aria-checked]="isSelectedLanguage('en')"
          (click)="selectLanguage('en')">
          <span class="public-language-option-label">
            <span class="public-language-flag" aria-hidden="true">🇬🇧</span>
            <span>{{ 'languages.en' | translate }}</span>
          </span>
          @if (isSelectedLanguage('en')) {
            <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
          }
        </button>
        <button
          type="button"
          class="public-language-option"
          role="radio"
          [class.selected]="isSelectedLanguage('hr')"
          [attr.aria-checked]="isSelectedLanguage('hr')"
          (click)="selectLanguage('hr')">
          <span class="public-language-option-label">
            <span class="public-language-flag" aria-hidden="true">🇭🇷</span>
            <span>{{ 'languages.hr' | translate }}</span>
          </span>
          @if (isSelectedLanguage('hr')) {
            <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
          }
        </button>
      </div>
    </section>
  } @else {
  @if (previewLoadingVisible) {
    <section class="guest-owner-panel">
      <app-loading-state titleKey="publicInvite.loadingInvite" [compact]="true"></app-loading-state>
    </section>
  }

  @if (errorMsg) {
    <div class="alert alert-danger">{{errorMsg}}</div>
  }

  @if ((inviteReady$ | async) && inviteUnavailable) {
    <section class="guest-owner-panel">
      <h2>{{ 'publicInvite.unavailableTitle' | translate }}</h2>
      <p>{{inviteUnavailableMsg}}</p>
    </section>
  }

  @if ((inviteReady$ | async) && invite) {
    <app-guest-match-header
      [title]="invite.name"
      [showBack]="true"
      [backLabel]="'publicInvite.changeLanguage' | translate"
      (back)="showLanguageChooser()">
    </app-guest-match-header>
    <app-guest-match-info-grid
      [timeLabel]="'guestOwner.matchTime' | translate"
      [timeValue]="inviteDate()"
      [timeDetail]="inviteStartTime()"
      [locationLabel]="'guestOwner.matchLocation' | translate"
      [locationValue]="inviteLocation()"
      [locationDetail]="inviteAddress()">
      <ng-container time-extra>
        @if (matchTimeChanged) {
          <div class="public-match-card-notice is-danger">
            <span>
              <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
              {{ 'publicInvite.matchTimeChanged' | translate }}
            </span>
            <button type="button"
              [attr.aria-label]="'publicInvite.dismissMatchTimeChanged' | translate"
              [title]="'common.close' | translate"
              (click)="dismissMatchTimeChanged()">
              <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
            </button>
          </div>
        }
      </ng-container>
      <ng-container location-extra>
        @if (matchLocationChanged) {
          <div class="public-match-card-notice is-danger">
            <span>
              <i [class]="'common.info' | nogoshIcon" aria-hidden="true"></i>
              {{ 'publicInvite.matchLocationChanged' | translate }}
            </span>
            <button type="button"
              [attr.aria-label]="'publicInvite.dismissMatchLocationChanged' | translate"
              [title]="'common.close' | translate"
              (click)="dismissMatchLocationChanged()">
              <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
            </button>
          </div>
        }
      </ng-container>
    </app-guest-match-info-grid>
  }

  @if ((inviteReady$ | async) && invite && invite.inviteActive) {
    @if (authenticatedPlayer) {
      <section class="public-match-section">
        <h2>{{ 'publicInvite.accountContext' | translate }}</h2>
        <p>{{ authenticatedPlayer.nickName || authenticatedPlayer.name }}</p>
        <p>{{ (savedResponse ? 'publicInvite.connectAnswerHint' : 'publicInvite.joinHint') | translate }}</p>
        @if (errorMsg) { <p role="alert">{{ errorMsg }}</p> }
        <button type="button" class="btn btn-primary" [disabled]="submitting" (click)="joinWithAccount()">
          {{ (savedResponse ? 'publicInvite.connectAnswer' : 'publicInvite.joinAction') | translate }}
        </button>
      </section>
    } @else {
    <section class="public-match-section public-response-section">
      <h2>{{ 'publicInvite.yourAnswer' | translate }}</h2>
      <div class="card match-response-card">
        <div class="card-body py-3">
          <div class="public-response-form">
            <div class="public-response-identity">
              <div class="public-player-avatar" aria-hidden="true">
                {{(name || savedName || '?').trim().charAt(0) || '?'}}
              </div>
              @if (showNameEditor()) {
                <div #nameEditor class="public-response-name-editor">
                  <label for="rsvpName" class="sr-only">{{ 'guestOwner.yourName' | translate }}</label>
                  <input id="rsvpName" name="rsvpName" class="form-control" [placeholder]="'guestOwner.yourName' | translate"
                    [(ngModel)]="name"
                    (ngModelChange)="clearNameError()"
                    autocomplete="name"
                    [disabled]="submitting"
                    [class.is-invalid]="nameErrorMsg">
                  @if (savedResponse) {
                    <button type="button" class="public-response-save-name"
                      [attr.aria-label]="'publicInvite.saveName' | translate"
                      [title]="'publicInvite.saveName' | translate"
                      [disabled]="submitting || !hasNameChanged() || !(name || '').trim()"
                      (click)="saveName()">
                      <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                  }
                  @if (nameErrorMsg) {
                    <div class="public-response-name-error">{{nameErrorMsg}}</div>
                  }
                </div>
              } @else {
                <div class="public-response-name">
                  <div>
                    <strong>{{savedName}}</strong>
                    <button type="button" class="public-response-name-edit"
                      [attr.aria-label]="'publicInvite.editName' | translate"
                      [title]="'publicInvite.editName' | translate"
                      [disabled]="submitting"
                      (click)="editName($event)">
                      <i [class]="'common.edit' | nogoshIcon" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
            <div class="match-response-actions">
              <div
                class="match-response-control"
                [class.is-saving]="submitting"
                [class.is-awaiting-response]="!savedResponse">
                <button type="button"
                  class="match-response-segment match-response-play"
                  [class.is-active]="savedResponse === positiveResponseType()"
                  [disabled]="responseButtonDisabled()"
                  (click)="rsvp(positiveResponseType())">
                  @if (submitting && selectedResponse === positiveResponseType()) {
                    <app-delayed-indicator></app-delayed-indicator>
                  }
                  @if (!(submitting && selectedResponse === positiveResponseType())) {
                    <i [class]="('common.check' | nogoshIcon) + ' match-response-segment-icon'" aria-hidden="true"></i>
                  }
                  <span>{{ responseButtonLabel(positiveResponseType()) }}</span>
                </button>
                <button type="button"
                  class="match-response-segment match-response-decline"
                  [class.is-active]="savedResponse === 'NOT_COMING'"
                  [disabled]="responseButtonDisabled()"
                  (click)="rsvp('NOT_COMING')">
                  @if (submitting && selectedResponse === 'NOT_COMING') {
                    <app-delayed-indicator></app-delayed-indicator>
                  }
                  @if (!(submitting && selectedResponse === 'NOT_COMING')) {
                    <i [class]="('common.close' | nogoshIcon) + ' match-response-segment-icon'" aria-hidden="true"></i>
                  }
                  <span>{{ responseButtonLabel('NOT_COMING') }}</span>
                </button>
              </div>
            </div>
          </div>
          @if (!savedResponse && !submitting) {
            <div class="match-response-helper">{{ 'publicInvite.response.choosePlayOrPass' | translate }}</div>
          }
          @if (savedResponse && !submitting) {
            <div class="match-response-status mt-3"
              [class.is-confirmed]="savedResponse === 'COMING'"
              [class.is-team]="savedResponse === 'JOIN_TEAM'"
              [class.is-declined]="savedResponse === 'NOT_COMING'">
              <i
                [class]="(savedResponse === 'COMING'
                  ? ('common.selected' | nogoshIcon)
                  : savedResponse === 'JOIN_TEAM'
                    ? ('player.add' | nogoshIcon)
                    : ('match.status.declined' | nogoshIcon)) + ' mr-2'"
                aria-hidden="true"></i>
              <div>
                <div class="match-response-status-title">{{savedResponseTitle()}}</div>
                @if (savedResponseTime()) {
                  <div class="match-response-status-text">{{ 'events.responseSavedAtLabel' | translate }} {{ savedResponseTime() }}</div>
                }
              </div>
            </div>
          }
          @if (submitting) {
            <div class="match-response-status is-saving mt-3">
              <app-delayed-indicator></app-delayed-indicator>
              <div>
                <div class="match-response-status-title">{{ 'events.savingResponse' | translate }}</div>
                <div class="match-response-status-text">{{ 'events.pleaseWait' | translate }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    </section>

    @if (savedResponse) {
    <p role="status">{{ 'publicInvite.answerComplete' | translate }}</p>
    <app-guest-profile-nudge
      [title]="'publicInvite.profileNudge.title' | translate"
      [description]="'publicInvite.profileNudge.description' | translate"
      [actionLabel]="'guestOwner.createProfile' | translate"
      (action)="createProfile()">
    </app-guest-profile-nudge>
    } @else {
      <button type="button" class="btn btn-link" (click)="createProfile()">{{ 'guestOwner.createProfile' | translate }}</button>
    }
    <button type="button" class="btn btn-link" (click)="authenticateFromInvite()">{{ 'publicInvite.existingAccount' | translate }}</button>
    }

    <app-guest-app-downloads
      [title]="(isMobileBrowser ? 'publicInvite.appDownload.preferApp' : 'publicInvite.appDownload.desktopTitle') | translate"
      [description]="(isMobileBrowser ? 'publicInvite.appDownload.instructions' : 'publicInvite.appDownload.desktopInstructions') | translate"
      [openLabel]="'publicInvite.appDownload.continueInApp' | translate"
      [openUrl]="''"
      [showOpenLink]="isMobileBrowser"
      [opening]="openingMobileApp"
      (openRequested)="continueInMobileApp()"
      [androidUrl]="androidDownloadUrl()"
      [iosUrl]="iosDownloadUrl()">
    </app-guest-app-downloads>

    <section class="public-match-section public-participants guest-flow-separated-section">
      <app-guest-participant-section-header
        [title]="'guestOwner.comingPlayers' | translate:{count: comingParticipants().length}"
        [chatLabel]="'guestOwner.chat.title' | translate"
        (chat)="openChatBridge()">
      </app-guest-participant-section-header>
      @if (participantsLoading) {
        <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
      }
        @if (participantListMsg) {
          <p class="empty-state">{{participantListMsg}}</p>
        }
        @if (!participantListMsg && participants.length === 0 && !participantsLoading) {
          <p class="empty-state">{{ 'publicInvite.noResponses' | translate }}</p>
        }
        @if (comingParticipants().length > 0) {
          <app-guest-participant-list [items]="comingParticipantItems()"></app-guest-participant-list>
        }
        @if (joinedTeamParticipants().length > 0) {
          <h2 class="public-secondary-heading">{{ 'publicInvite.participants.joinedTeamCount' | translate:{count: joinedTeamParticipants().length} }}</h2>
          <app-guest-participant-list [items]="joinedTeamParticipantItems()"></app-guest-participant-list>
        }
        @if (notComingParticipants().length > 0) {
          <h2 class="public-secondary-heading">{{ 'publicInvite.participants.notComingCount' | translate:{count: notComingParticipants().length} }}</h2>
          <app-guest-participant-list [items]="notComingParticipantItems()"></app-guest-participant-list>
        }
    </section>
  }

  @if ((inviteReady$ | async) && invite && !invite.inviteActive) {
    <section class="guest-owner-panel">
      <h2>{{ 'publicInvite.closedTitle' | translate }}</h2>
      <p>{{ 'publicInvite.errors.inviteInactive' | translate }}</p>
    </section>
  }

  @if (chatBridgeVisible) {
    <div class="public-chat-bridge" role="presentation">
      <button type="button"
        class="public-chat-bridge-backdrop"
        [attr.aria-label]="'common.close' | translate"
        (click)="closeChatBridge()">
      </button>
      <section class="public-chat-bridge-card" role="alertdialog" aria-modal="true" aria-labelledby="publicChatBridgeTitle">
        <div class="public-chat-bridge-icon" aria-hidden="true">
          <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
        </div>
        <h2 id="publicChatBridgeTitle">{{ 'guestOwner.chat.title' | translate }}</h2>
        <p>{{ 'guestOwner.chat.previewDescription' | translate }}</p>
        <div class="public-chat-preview" role="log" [attr.aria-label]="'publicInvite.chat.previewTitle' | translate">
          @if (chatPreviewLoading) {
            <div class="public-chat-preview-state">
              <app-delayed-indicator></app-delayed-indicator>
              {{ 'guestOwner.chat.loading' | translate }}
            </div>
          }
          @if (!chatPreviewLoading && chatPreviewUnavailable) {
            <div class="public-chat-preview-state">{{ 'publicInvite.chat.unavailable' | translate }}</div>
          }
          @if (!chatPreviewLoading && !chatPreviewUnavailable && publicChatMessages.length === 0) {
            <div class="public-chat-preview-state">{{ 'guestOwner.chat.empty' | translate }}</div>
          }
          @if (!chatPreviewLoading && publicChatMessages.length > 0) {
            @for (message of publicChatMessages; track message.id) {
              <article class="public-chat-message">
                <header>
                  <strong>{{ chatMessageSender(message) }}</strong>
                  @if (chatMessageTime(message)) {
                    <small>{{ chatMessageTime(message) }}</small>
                  }
                </header>
                <p>{{ chatMessageText(message) }}</p>
              </article>
            }
          }
        </div>
        <p class="public-chat-compose-note">{{ 'guestOwner.chat.composeDescription' | translate }}</p>
        <button type="button" class="public-chat-bridge-secondary" (click)="closeChatBridge()">{{ 'common.cancel' | translate }}</button>
        <button type="button" class="public-chat-bridge-primary" (click)="createProfileFromChat()">{{ 'guestOwner.chat.createAccountCta' | translate }}</button>
      </section>
    </div>
  }
  }
</app-screen-shell>
